import React, {Component} from 'react'

import { connect } from 'react-redux'
import ReleasedAssignmentList from './components/Assignment/ReleasedAssignmentList'

import {
  fetchSlimAccount,
} from 'broker/redux/account'
import {
  fetchReleasedAssignments
} from 'broker/redux/assignment'

import { UNIVERSAL_EXPORT_TIMEFRAME_MONTH } from 'common/constants'
import {getAuthEmail} from "broker/util/downloader";


const mapDispatchToProps = dispatch => ({
    dispatch
})

class AssignmentContainer extends Component {

    constructor(props) {
      super(props)
    }

    componentWillMount() {
      const { dispatch, assignment } = this.props
      dispatch(fetchReleasedAssignments(UNIVERSAL_EXPORT_TIMEFRAME_MONTH))
      dispatch(fetchSlimAccount())
    }

    render() {
      return <ReleasedAssignmentList {...this.props} />
    }
}

export default connect((state) => ({ assignment: state.assignment, account: state.account, email: getAuthEmail(state), auth: state.auth, root: state.root  }), mapDispatchToProps)(AssignmentContainer)
